import { BaseModel } from '@/models/BaseModel';
import { BaseCollection } from './BaseCollection';
import type { MutationsObject } from '@kp/js-model';
import type { Dayjs } from 'dayjs';
import dayjs from 'dayjs';

export const ROLES = {
    berechnungsgrundlagen_allgemein: 'berechnungsgrundlagen_allgemein',
    berechnungsgrundlagen_gebaeude: 'berechnungsgrundlagen_gebaeude',
    berechnungsgrundlagen_produktion: 'berechnungsgrundlagen_produktion',
    berechnungsgrundlagen_jahreswerte: 'berechnungsgrundlagen_jahreswerte',
    datenimport: 'datenimport',
    berechnungen: 'berechnungen',
    auswertungen: 'auswertungen',
    systemeinstellungen: 'systemeinstellungen',
    berechnete_listen: 'berechnete_listen',
};

export class Rolle extends BaseModel {
    // properties
    id: number | null = null;
    created: Dayjs | null = null;
    modified: Dayjs | null = null;
    creator_id: number | null = null;
    modifier_id: number | null = null;

    reihenfolge: number | null = null;
    bezeichnung: string | null = null;
    berechnungsgrundlagen_allgemein: boolean | null = null;
    berechnungsgrundlagen_gebaeude: boolean | null = null;
    berechnungsgrundlagen_produktion: boolean | null = null;
    berechnungsgrundlagen_jahreswerte: boolean | null = null;
    datenimport: boolean | null = null;
    berechnungen: boolean | null = null;
    auswertungen: boolean | null = null;
    systemeinstellungen: boolean | null = null;
    berechnete_listen: boolean | null = null;
    bemerkung: string | null = null;

    public mutations(): MutationsObject {
        return {
            created: (val) => dayjs(val),
            modified: (val) => dayjs(val),
        };
    }

    getClassName(): string {
        return 'Rolle';
    }
}

export class RolleCollection extends BaseCollection<Rolle> {
    protected modelCls = Rolle;

    public getModelClassName(): string {
        return 'Rolle';
    }
}

let _globalRolleCollection: RolleCollection | null = null;

/**
 * global (single instance) collection: To be used where a global, shared instance can be used.
 * Note that this collection MUST NOT be filered / ordered on other places, as it is a shared instance!
 * @returns
 */
export function globalRolleCollection(): RolleCollection {
    if (!_globalRolleCollection) {
        _globalRolleCollection = new RolleCollection();
        _globalRolleCollection.setQueryParams({
            sort: [
                {
                    property: 'reihenfolge',
                    direction: 'asc',
                },
                {
                    property: 'bezeichnung',
                    direction: 'asc',
                },
                {
                    property: 'id',
                    direction: 'asc',
                },
            ],
        });
        _globalRolleCollection.query();
    }
    return _globalRolleCollection;
}
